module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "90%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#fm-1"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#ch-1"
    }
  }, [_vm._v("I.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#ch-1"
    }
  }, [_vm._v("Two Cities Called Chicago")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#ch-2"
    }
  }, [_vm._v("II.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#ch-2"
    }
  }, [_vm._v("Read All About It: The Official Story Emerges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Police in Action")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Usual Sustpects: Stirrings on the Left Wing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Room for Neutrality: The Jewish Community Reacts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fight for Control of the Story")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fight Continues: Tug-of-War Over Averbuch’s Body")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repercussions")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Affair Goes National: Congress Quarrels and Emma Finds a Lover")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inquest")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Sense of It All: Theories Abound")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018_Afterword#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019_Endnotes#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020_Bibliography#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v("Index of Newspapers and Magazines")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021_Abouttheauthors#bm-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecb6352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 69
// module chunks = 0